/**
 * @fileoverview gRPC-Web generated client stub for fitness.service.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.1.1
// 	protoc              v0.0.0
// source: fitness-service/v1/admin.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.fitness = {};
proto.fitness.service = {};
proto.fitness.service.v1 = require('./admin_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.AdminServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.AdminServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetPendingAgenciesRequest,
 *   !proto.fitness.service.v1.GetPendingAgenciesResponse>}
 */
const methodDescriptor_AdminService_GetPendingAgencies = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AdminService/GetPendingAgencies',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetPendingAgenciesRequest,
  proto.fitness.service.v1.GetPendingAgenciesResponse,
  /**
   * @param {!proto.fitness.service.v1.GetPendingAgenciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetPendingAgenciesResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetPendingAgenciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetPendingAgenciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetPendingAgenciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AdminServiceClient.prototype.getPendingAgencies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetPendingAgencies',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetPendingAgencies,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetPendingAgenciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetPendingAgenciesResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AdminServicePromiseClient.prototype.getPendingAgencies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetPendingAgencies',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetPendingAgencies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.ApproveAgencyRequest,
 *   !proto.fitness.service.v1.ApproveAgencyResponse>}
 */
const methodDescriptor_AdminService_ApproveAgency = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AdminService/ApproveAgency',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.ApproveAgencyRequest,
  proto.fitness.service.v1.ApproveAgencyResponse,
  /**
   * @param {!proto.fitness.service.v1.ApproveAgencyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.ApproveAgencyResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.ApproveAgencyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.ApproveAgencyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.ApproveAgencyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AdminServiceClient.prototype.approveAgency =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AdminService/ApproveAgency',
      request,
      metadata || {},
      methodDescriptor_AdminService_ApproveAgency,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.ApproveAgencyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.ApproveAgencyResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AdminServicePromiseClient.prototype.approveAgency =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AdminService/ApproveAgency',
      request,
      metadata || {},
      methodDescriptor_AdminService_ApproveAgency);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.RejectAgencyRequest,
 *   !proto.fitness.service.v1.RejectAgencyResponse>}
 */
const methodDescriptor_AdminService_RejectAgency = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AdminService/RejectAgency',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.RejectAgencyRequest,
  proto.fitness.service.v1.RejectAgencyResponse,
  /**
   * @param {!proto.fitness.service.v1.RejectAgencyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.RejectAgencyResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.RejectAgencyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.RejectAgencyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.RejectAgencyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AdminServiceClient.prototype.rejectAgency =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AdminService/RejectAgency',
      request,
      metadata || {},
      methodDescriptor_AdminService_RejectAgency,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.RejectAgencyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.RejectAgencyResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AdminServicePromiseClient.prototype.rejectAgency =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AdminService/RejectAgency',
      request,
      metadata || {},
      methodDescriptor_AdminService_RejectAgency);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetAdminStatsRequest,
 *   !proto.fitness.service.v1.GetAdminStatsResponse>}
 */
const methodDescriptor_AdminService_GetAdminStats = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AdminService/GetAdminStats',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetAdminStatsRequest,
  proto.fitness.service.v1.GetAdminStatsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetAdminStatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetAdminStatsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetAdminStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetAdminStatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetAdminStatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AdminServiceClient.prototype.getAdminStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetAdminStats',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetAdminStats,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetAdminStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetAdminStatsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AdminServicePromiseClient.prototype.getAdminStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetAdminStats',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetAdminStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetAllAgenciesRequest,
 *   !proto.fitness.service.v1.GetAllAgenciesResponse>}
 */
const methodDescriptor_AdminService_GetAllAgencies = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AdminService/GetAllAgencies',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetAllAgenciesRequest,
  proto.fitness.service.v1.GetAllAgenciesResponse,
  /**
   * @param {!proto.fitness.service.v1.GetAllAgenciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetAllAgenciesResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetAllAgenciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetAllAgenciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetAllAgenciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AdminServiceClient.prototype.getAllAgencies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetAllAgencies',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetAllAgencies,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetAllAgenciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetAllAgenciesResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AdminServicePromiseClient.prototype.getAllAgencies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetAllAgencies',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetAllAgencies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetAgencyDetailsRequest,
 *   !proto.fitness.service.v1.GetAgencyDetailsResponse>}
 */
const methodDescriptor_AdminService_GetAgencyDetails = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AdminService/GetAgencyDetails',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetAgencyDetailsRequest,
  proto.fitness.service.v1.GetAgencyDetailsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetAgencyDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetAgencyDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetAgencyDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetAgencyDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetAgencyDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AdminServiceClient.prototype.getAgencyDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetAgencyDetails',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetAgencyDetails,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetAgencyDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetAgencyDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AdminServicePromiseClient.prototype.getAgencyDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetAgencyDetails',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetAgencyDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetIndependentTrainersRequest,
 *   !proto.fitness.service.v1.GetIndependentTrainersResponse>}
 */
const methodDescriptor_AdminService_GetIndependentTrainers = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AdminService/GetIndependentTrainers',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetIndependentTrainersRequest,
  proto.fitness.service.v1.GetIndependentTrainersResponse,
  /**
   * @param {!proto.fitness.service.v1.GetIndependentTrainersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetIndependentTrainersResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetIndependentTrainersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetIndependentTrainersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetIndependentTrainersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AdminServiceClient.prototype.getIndependentTrainers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetIndependentTrainers',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetIndependentTrainers,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetIndependentTrainersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetIndependentTrainersResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AdminServicePromiseClient.prototype.getIndependentTrainers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AdminService/GetIndependentTrainers',
      request,
      metadata || {},
      methodDescriptor_AdminService_GetIndependentTrainers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.SetAgencyBrandingRequest,
 *   !proto.fitness.service.v1.SetAgencyBrandingResponse>}
 */
const methodDescriptor_AdminService_SetAgencyBranding = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AdminService/SetAgencyBranding',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.SetAgencyBrandingRequest,
  proto.fitness.service.v1.SetAgencyBrandingResponse,
  /**
   * @param {!proto.fitness.service.v1.SetAgencyBrandingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.SetAgencyBrandingResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.SetAgencyBrandingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.SetAgencyBrandingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.SetAgencyBrandingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AdminServiceClient.prototype.setAgencyBranding =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AdminService/SetAgencyBranding',
      request,
      metadata || {},
      methodDescriptor_AdminService_SetAgencyBranding,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.SetAgencyBrandingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.SetAgencyBrandingResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AdminServicePromiseClient.prototype.setAgencyBranding =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AdminService/SetAgencyBranding',
      request,
      metadata || {},
      methodDescriptor_AdminService_SetAgencyBranding);
};


module.exports = proto.fitness.service.v1;

